import { SessionService } from '@services/session/session.service';
import { UserService } from '@services/user/user.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { OktaAuthService } from '@common_libraries/Services/login/oktaAuth.service';
import { environment } from '@environments/environment';
import { CompanyModel } from '@pageControls/company-picker/model/company-picker.model';
import { ModuleAuth } from '@common_libraries/lib/ModuleAuth';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, RoutesRecognized } from '@angular/router';
import { LogoutReasons } from '@common_libraries/lib/Enums';

@Component({
    templateUrl: './oktaCallback.component.html',
    standalone: true
})
export class OktaCallbackComponent implements OnInit, OnDestroy {
  //public companies: Array<CompanyModel>;
  return_to: string;
  private obSubs: any = [];
  constructor(
    private okta: OktaAuthService,
    private localSt: LocalStorageService,
    private userService: UserService,
    private sessionService: SessionService,
    private moduleAuth: ModuleAuth,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.obSubs.push(this.okta.oktaReadyObservable.subscribe((ready) => {
      if (ready) {
        // Handles the response from Okta and parses tokens
        this.okta.handleAuthentication(false).then((res) => {
          this.obSubs.push(this.okta.oktaSetReadyObservable.subscribe((setReady) => {
            if (setReady) {
              this.getToken();
            }
          }));
        });
      }
    }));
  }

  ngOnDestroy() {
    this.obSubs.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  getToken() {
    this.obSubs.push(this.okta.oktaSetReadyObservable.subscribe((ready) => {
      this.okta.oktaAuth.tokenManager.get('accessToken').then((token) => {
        if (token) {
          // before redirecting, check if we need to do a terms of use update for this login
          const needsTermsUpdate = JSON.parse(sessionStorage.getItem('doTermsOfUseUpdate'));
          if (needsTermsUpdate) {
            this.userService.AcceptTermsOfUse(1).subscribe(() => {
              sessionStorage.removeItem('doTermsOfUseUpdate');
              this.redirect();
            });
          } else {
            this.redirect();
          }
        } else {
          window.location.href = '/login';
        }
      });
    }));
    
  }

  private redirect() {
    // if a redirect URL has been set and its 30 minutes old or less, use it
    let redURL = this.localSt.retrieve('redirect_url');
    try {
      if (redURL != null) {
        const redURLCreate = this.localSt.retrieve('redirect_url_create');
        if (redURLCreate != null) {
          const durationInMinutes = Math.floor(
            (Date.now().valueOf() - redURLCreate.valueOf()) / 1000 / 60
          );
          if (durationInMinutes > 30) {
            redURL = '/'; // redirect URL is older than 30 minutes
          }
        } else {
          redURL = '/'; // somehow the redirect_url_create value was not set
        }
      } else {
        redURL = '/'; // the redirect_url was not set
      }
    } catch (e) {
      redURL = '/'; // something broke, forget about the redirect URL
    }

    if (String(redURL).includes('login')) {
      redURL = '/';
    }

    // this.sessionService.SetIsLoggedIn(true);
    this.localSt.clear('redirect_url_create');
    this.localSt.clear('redirect_url');

    this.SetupUserCompanyData(redURL);
  }

  private SetupUserCompanyData(redURL: string) {
    // Get top company user belongs to
    this.userService.GetTopCompanyForUser().subscribe((res: any) => {

      // check if company is saved in local storage, if not use top company for user
      const pCompany = this.sessionService.GetSelectedCompanyID() === 0 ? res.json.data : this.sessionService.GetSelectedCompanyID();
      this.SelectCompanyAndRedirect(pCompany, redURL);

    });
  }

  private SelectCompanyAndRedirect(company: any, redURL: string) {
    if( company === null) { // users may hit this when they have been deactivated in the system
      window.location.href = '/login/' + LogoutReasons.IncorrectPasswordUser;
    }
    this.sessionService.SetSelectedCompanyID(company);
    this.sessionService.SetSelectedCompanyTheme(company);
    this.moduleAuth.SetupModuleAuthData().subscribe((moduleData: any) => {
      // If return_to is set in querystring,it will get pushed to session service on login.modle
      // if it is returned from session service, instead of setting up user and company data, we are going to send them back to zendesk
      // because return_to means we are doing a zendesk SSO
      this.return_to = this.sessionService.GetZendeskReturnTo();
      if (
        this.return_to === undefined ||
        this.return_to === null ||
        this.return_to === ''
      ) {
        // return_to is not set, so do our standard login flow

        // setup up a catcher to see if we try to redirect to 404 page on login because of a bad redURL
        // and send to analysis instead
        // this subscription will be destroyed/unsubscribed during the destroy for this component after navigation
        this.obSubs.push(this.router.events.subscribe((event: Event) => {
          if (event instanceof RoutesRecognized) {
            if (event.urlAfterRedirects.toLowerCase().indexOf('404') > -1) {
              redURL = '/analysis';
              this.router.navigate([redURL]);
            }
          }
        }));
        this.router.navigate([redURL]);
      } else {
        this.sessionService.ClearZendeskReturnTo();
        this.userService.GetHelpLink().subscribe((res: any) => {
          window.location.href = res.url;
        });
      }
    });
  }
}
